var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{ref:"app_bar",attrs:{"scroll-threshold":50,"color":"primary accent-4","hide-on-scroll":"","app":"","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$emit('navigation_drawer')}}}),_c('v-toolbar-title',{staticClass:"align-center justify-center"},[_vm._v(" "+_vm._s(_vm.translate('auth.title'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }